var e;!function(e){e.FILE="file",e.INVITE="userInvite",e.CONVERSATION="conversation",e.USER_PROFILE="userProfile"}(e||(e={}));export{e as RoqResourceEnum};